<template>
  <div class="shop_info">
    <template v-if="form['merchantNum']">
      <el-form-item :label="language('shopInformation.merchantNum')">
        <div class="input">{{ form["merchantNum"] }}</div>
      </el-form-item>
    </template>
    <!-- <el-form-item label="Merchant ID">
      <div class="input">111111</div>
    </el-form-item>
    <el-form-item label="Merchant Administrator">
      <div class="input">111111</div>
    </el-form-item>-->

    <el-form-item
      :label="language('shopInformation.shopNameChi')"
      prop="nameChi"
    >
      <div class="input">
        <el-input v-model="form['nameChi']"></el-input>
      </div>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.shopNameEng')"
      prop="nameEng"
    >
      <div class="input">
        <el-input v-model="form['nameEng']"></el-input>
      </div>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.aliasName')"
      prop="aliasName"
    >
      <div class="input">
        <template v-if="form['id']">
          {{ form["aliasName"] }}
        </template>
        <template v-else>
          <el-input
            v-model="form['aliasName']"
            :disabled="form['id'] ? true : false"
          ></el-input>
        </template>
      </div>
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.categoryId')"
      prop="categoryIds"
    >
      <div class="input">
        <el-select
          v-model="form['categoryIds']"
          placeholder
          multiple
          style="width: 100%"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.nameChi"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.logo')" prop="logo">
      <cc-uploader
        :config="uploaderConf"
        v-model="form['logo']"
        fType="image"
        :info="language('common.uploaderInfo')"
        :fFormatV2="['.jpg', '.png']"
      />
    </el-form-item>
    <el-form-item :label="language('shopInformation.theme')" prop="colorTheme">
      <el-color-picker v-model="form.colorTheme" show-alpha></el-color-picker>
      {{ form.colorTheme }}
    </el-form-item>
    <el-form-item
      :label="language('shopInformation.banner')"
      prop="topBannerImg"
    >
      <cc-uploader
        :config="uploaderConf"
        v-model="form['topBannerImg']"
        fType="image"
        :info="language('common.uploaderInfo')"
        :fFormatV2="['.jpg', '.png']"
      />
    </el-form-item>
    <el-form-item :label="language('shopInformation.shopLocation') + ' 1'">
      <div class="location">
        <div class="title">{{ language("shopInformation.addressChi") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][0]['addressChi']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.addressEng") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][0]['addressEng']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.contact") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][0]['contactPhone']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.district") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][0]['region']"
            placeholder
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="location">
        <div class="title">{{ language("shopInformation.sequence") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][0]['sequence']"
            placeholder
          >
            <el-option
              v-for="item in optionsSequence"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div> -->
    </el-form-item>
    <el-form-item :label="language('shopInformation.shopLocation') + ' 2'">
      <div class="location">
        <div class="title">{{ language("shopInformation.addressChi") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][1]['addressChi']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.addressEng") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][1]['addressEng']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.contact") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][1]['contactPhone']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.district") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][1]['region']"
            placeholder
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="location">
        <div class="title">{{ language("shopInformation.sequence") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][1]['sequence']"
            placeholder
          >
            <el-option
              v-for="item in optionsSequence"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div> -->
    </el-form-item>
    <el-form-item :label="language('shopInformation.shopLocation') + ' 3'">
      <div class="location">
        <div class="title">{{ language("shopInformation.addressChi") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][2]['addressChi']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.addressEng") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][2]['addressEng']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.contact") }}</div>
        <div class="value">
          <el-input
            v-model="form['mchShopLocations'][2]['contactPhone']"
          ></el-input>
        </div>
      </div>
      <div class="location">
        <div class="title">{{ language("shopInformation.district") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][2]['region']"
            placeholder
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="location">
        <div class="title">{{ language("shopInformation.sequence") }}</div>
        <div class="value">
          <el-select
            v-model="form['mchShopLocations'][2]['sequence']"
            placeholder
          >
            <el-option
              v-for="item in optionsSequence"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div> -->
    </el-form-item>
  </div>
</template>
<script>
import uploadUtils from "../../../../utils/ossUtils";

export default {
  model: {
    prop: "forms",
    event: "change",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      defaultCascaderProps: {
        children: "subCategoryList",
        label: "nameChi",
        value: "id",
      },
      categories: [],
      options: [
        {
          value: "Causewaybay",
          label: "Causewaybay",
        },
        {
          value: "Eastern, Hong Kong",
          label: "Eastern, Hong Kong",
        },
        {
          value: "Western, Hong Kong",
          label: "Western, Hong Kong",
        },
        {
          value: "WanChai, Hong Kong",
          label: "WanChai, Hong Kong",
        },
      ],
      optionsSequence: [
        {
          value: 1,
          label: 1,
        },
        {
          value: 2,
          label: 2,
        },
        {
          value: 3,
          label: 3,
        },
      ],
      uploaderConf: uploadUtils.configPublish,
      form: {
        id: "",
        mchShopLocations: [
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            appId: "supnr",
          },
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            appId: "supnr",
          },
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            appId: "supnr",
          },
        ],
      },
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  watch: {
    form: {
      handler() {
        let url = "/perm/shop/";
        if (this.form.merchantNum) {
          url = "/perm/shop/" + this.form.merchantNum + "/";
        }
        this.uploaderConf = uploadUtils.configPublishV2(url);
        // console.log( this.uploaderConf)
        this.$emit("change", this.form);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
  mounted() {
    if (this.formData.id) {
      // for (let i = 0; i < this.formData.mchShopLocations.length; i++) {
      //   this.formData.mchShopLocations[i].sequence = i + 1;
      // }
      this.form = {
        merchantNum: this.formData.merchantNum,
        aliasName: this.formData.aliasName,
        nameChi: this.formData.nameChi,
        nameEng: this.formData.nameEng,
        logo: this.formData.logo,
        colorTheme: this.formData.colorTheme,
        topBannerImg: this.formData.topBannerImg,
        mchShopLocations: this.formData.mchShopLocations,
        categoryIds: this.formData.categoryIds,
        id: this.formData.id,
        shopNum: this.formData.shopNum
      };

      if (
        this.formData.mchShopLocations &&
        this.formData.mchShopLocations.length == 0
      ) {
        this.form.mchShopLocations = [
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            appId: "supnr",
            sequence: 1,
          },
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            appId: "supnr",
            sequence: 2,
          },
          {
            addressChi: "",
            addressEng: "",
            contactPhone: "",
            region: "",
            sequence: 3,
            appId: "supnr",
          },
        ];
      }
    }

    this.ccRequest
      .do("admin/merchant/shop/category/query", {}, "GET")
      .then((res) => {
        // this.categories = res.map(item => this.removeEmptySubCategoryList(item));
        // console.log("testing", this.removeEmptySubCategoryList(res[0]));\

        this.categories = res.rows;
      })
      .catch((err) => {
        this.$message.error(err.response.data.message);
      });
  },
};
</script>
<style scoped lang="scss">
.input {
  width: 500px;
}
.banner {
  width: 200px;
}
.location {
  margin-bottom: 20px;
  display: flex;
  width: 600px;
  .title {
    width: 100px;
  }
  .value {
    margin-left: 10px;
    width: 500px;
  }
}
</style>
<style lang="scss">
.shop_info {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>